export default __webpack_public_path__ + "static/media/IMG6788.0957a7d6.jpg";